import api from '@/lib/hippo'
import Vue from 'vue'
import Enrollment from '@/models/enrollment'
import Stage from '@/models/stage'
import Page from '@/models/page'
import Program from '@/models/program'
import Graph from '@/models/graph'
import AdditionalResource from '@/models/additional_resource'
import AdditionalResourceCategory from '@/models/additional_resource_category'

function initialState() {
  return {
    prescreens: {},
    enrollments: {},
    enrollment: {},
    program: {},
    stages: {},
    stage: {},
    pages: {},
    page: {},
    graphs: {},
    resources: {},
    flagged_ids: {},
    additional_resource_categories: {},
    isPlaying: false,
  };
}

const state = initialState;

const actions = {

  fetchPreScreens ( {commit, rootGetters} ) {
    return new Promise((resolve, reject) => {
      if (rootGetters.apiToken) {
        api.getPreScreens(rootGetters.apiToken)
           .then((response) => {
             commit ('setPreScreens', Program.from(response.data) );
             resolve(true);
           }).catch((err) => reject(err) );
      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  preScreenEnroll ({commit, rootGetters, dispatch}, program_id) {
    return new Promise((resolve, reject) => {
      if (rootGetters.apiToken) {
        api.postPreScreenEnrol(rootGetters.apiToken, program_id)
           .then((response) => {
             resolve(response.data.data.id);
           }).catch((err) => reject(err) );
      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  fetchEnrollments ( {commit, rootGetters} ) {
    return new Promise((resolve, reject) => {
      if (rootGetters.apiToken) {
        api.getEnrollments(rootGetters.apiToken)
           .then((response) => {
             commit ('setEnrollments', Enrollment.from(response.data) );
             resolve(true);
           }).catch((err) => reject(err) );
      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  fetchProgram ( {commit, rootGetters}, enrol_id ) {
    return new Promise((resolve, reject) => {
      if (rootGetters.apiToken) {
        api.getEnrollment(rootGetters.apiToken, enrol_id)
           .then((response) => {
             commit ('setEnrollment', Enrollment.from(response.data) );
             resolve(true);
           }).catch((err) => reject(err) );
      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  fetchStages ({commit, rootGetters}, enrol_id) {
    return new Promise((resolve, reject) => {
      if (rootGetters.apiToken) {
        api.getStages(rootGetters.apiToken, enrol_id)
           .then((response) => {
             commit ('setStages', Stage.from(response.data) );
             resolve(true);
           }).catch((err) => reject(err) );
      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  fetchStage ({commit, rootGetters}, {enrol_id, stage_id}) {
    return new Promise((resolve, reject) => {
      if (rootGetters.apiToken) {
        api.getStage(rootGetters.apiToken, enrol_id, stage_id)
           .then((response) => {
             commit ('setStage', Stage.from(response.data) );
             resolve(true);
           }).catch((err) => reject(err) );
      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  fetchContent ({commit, rootGetters}, {enrol_id, stage_id, task_id, page_id}) {
    return new Promise((resolve, reject) => {
      if (rootGetters.apiToken) {
        api.getContent(rootGetters.apiToken, enrol_id, stage_id, task_id, page_id)
           .then((response) => {
             let page = Page.from(response.data);
             commit ('setPage', { task_id: task_id, page: page });
             resolve(true);
           }).catch((err) => reject(err) );
      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  pageView ({rootGetters}, {enrol_id, stage_id, task_id, page_id}) {
    return new Promise((resolve, reject) => {
      if (rootGetters.apiToken) {
        api.putPageView(rootGetters.apiToken, enrol_id, stage_id, task_id, page_id)
           .then((response) => {
             resolve(true);
           }).catch((err) => reject(err) );
      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  enrollmentView ({commit, state, rootGetters}, enrol_id) {
    return new Promise((resolve, reject) => {
      if (rootGetters.apiToken) {
        api.postEnrollmentView(rootGetters.apiToken, enrol_id)
           .then((response) => {
             let e = Enrollment.from(response.data);
             if (state.enrollment.id==enrol_id){
               commit ('setEnrollment', e );
             }
             commit('setEnrollmentsById', e );
             resolve(true);
           }).catch((err) => reject(err) );

      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  enrollmentWithdraw ({commit, rootGetters, dispatch}, {enrol_id, note}) {
    return new Promise((resolve, reject) => {
      if (rootGetters.apiToken) {
        api.postWithdraw(rootGetters.apiToken, enrol_id, note)
           .then((response) => {
             dispatch('fetchEnrollments');
             resolve(true);
           }).catch((err) => reject(err) );
      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  fetchGraphs ({ rootGetters, state, commit}, enrol_id) {
    return new Promise((resolve, reject) => {
      if (enrol_id && rootGetters.apiToken) {
        api.getGraphs(rootGetters.apiToken, enrol_id)
          .then((response) => {
            commit('addClientGraphs', Graph.from(response.data) );
            resolve(true);
          }).catch( (err) => reject(err) );
      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  fetchResources ({ rootGetters, state, commit }, enrol_id) {
  return new Promise((resolve, reject) => {
      if (enrol_id && rootGetters.apiToken) {
        api.getResources(rootGetters.apiToken, enrol_id)
          .then((response) => {
            commit('addResources', AdditionalResource.from(response.data) );
            resolve(true);
          }).catch( (err) => reject(err) );
      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  fetchFlaggedResources ({ rootGetters, state, commit }, enrol_id) {
    return new Promise((resolve, reject) => {
        if (enrol_id && rootGetters.apiToken) {
          api.getFlaggedResources(rootGetters.apiToken, enrol_id)
            .then((response) => {
              commit('addFlaggedResources', response.data.data);
              resolve(true);
            }).catch( (err) => reject(err) );
        } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
      });
    },
  additionalResourceView ({rootGetters}, {enrol_id, resource_id}) {
    return new Promise((resolve, reject) => {
      if (rootGetters.apiToken) {
        api.putAdditionalResourceView(rootGetters.apiToken, enrol_id, resource_id)
         .then((response) => {
           resolve(true);
         }).catch((err) => reject(err) );
      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  pageResourceView ({rootGetters}, {enrol_id, stage_id, task_id, page_id, resource_id}) {
    return new Promise((resolve, reject) => {
      if (rootGetters.apiToken) {
        api.putPageResourceView(rootGetters.apiToken, enrol_id, stage_id, task_id, page_id, resource_id)
         .then((response) => {
           resolve(true);
         }).catch((err) => reject(err) );
      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  saveConsentDate ( {commit, rootGetters}, id ) {
    return new Promise((resolve, reject) => {
      if (rootGetters.apiToken) {
        api.saveConsentDate(rootGetters.apiToken, id)
           .then((response) => {
             resolve(true);
           }).catch((err) => reject(err) );
      } else reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  fetchAdditionalResourceCategories ({commit, state, rootGetters}) {
    return new Promise((resolve, reject) => {
        if (rootGetters.apiToken) {
            api.fetchAdditionalResourceCategories(rootGetters.apiToken).then( (response) => {
                let additional_resource_categories = AdditionalResourceCategory.from(response.data);

                commit ('addAdditionalResouceCategory', additional_resource_categories);
                resolve(true);
            }).catch((err) => reject(err) );
        } else  reject( new Error( ( !rootGetters.apiToken ) ? 'You are no longer logged in.' : 'Missing required parameter.' ) );
    });
  },
  resetProgramsState ( {commit} ) {
    commit('resetState');
  }
};

const mutations = {

  setPreScreens: (state, screens) => {
    Vue.set(state, 'prescreens', screens);
  },
  setEnrollments: (state, enrollments) => {
    Vue.set(state, 'enrollments', enrollments);
  },
  setEnrollmentsById: (state, enrollment) => {
    Vue.set(state.enrollments,enrollment.id,enrollment);
  },
  setEnrollment: (state, enrollment) => {
    Vue.set(state, 'enrollment', enrollment);
  },
  setProgram: (state, program) => {
    Vue.set(state, 'program', program);
  },
  setStages: (state, stages) => {
    Vue.set(state, 'stages', stages);
  },
  setStage: (state, stage) => {
    Vue.set(state, 'stage', stage);
  },
  setPage: (state, {task_id, page}) => {
    if (!state.pages) Vue.set(state, 'pages', {});
    if (!state.pages[task_id]) Vue.set(state.pages, task_id, {});
    Vue.set(state.pages[task_id], page.id, page);
  },
  setPageViewed: (state, {task_id, page_id}) => {
    if (state.pages && state.pages[task_id] && state.pages[task_id][page_id]) {
      Vue.set(state.pages[task_id][page_id], 'viewed', true);
    } else {
      //console.error ("Store object for page missing!");
      //console.error ({page_id, state_pages: state.pages});
    }
  },
  addClientGraphs: (state, graphs) => {
    Vue.set(state, 'graphs', graphs);
  },
  addResources: (state, resources) => {
    Vue.set(state, 'resources', resources);
  },
  addFlaggedResources: (state, flagged_ids) => {
    Vue.set(state, 'flagged_ids', flagged_ids);
  },
  addAdditionalResouceCategory: (state, additional_resource_categories) => {
    Vue.set(state, 'additional_resource_categories', additional_resource_categories);
},
  resetState (state) {
    const s = initialState();
    Object.keys(s).forEach(key => {
      Vue.set(state, key, s[key]);
    });
  }
};

export default {
  state,
  actions,
  mutations
}
